module.exports = __webpack_public_path__ + "img/asso_jeju01.a79c0be7.png";